/* Shreya — account drawer: switches between log in, password recovery and register views */
(() => {
  if (customElements.get('account-drawer-views')) return;

  class AccountDrawerViews extends HTMLElement {
    connectedCallback() {
      this.views = Array.from(this.querySelectorAll('[data-account-view]'));
      this.titleEl = this.querySelector('[data-account-title]');
      this.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-account-show]');
        if (!trigger) return;
        e.preventDefault();
        this.show(trigger.dataset.accountShow, true);
      });

      // Reset to the log in view each time the drawer closes
      this.drawer = this.closest('drawer-panel');
      if (this.drawer) {
        this.onClose = () => setTimeout(() => this.show(this.dataset.initial || 'login'), 500);
        this.drawer.addEventListener('drawer:close', this.onClose);
      }

      // Returning from a password reset request: reopen on that view
      if (window.location.hash === '#recover' && this.querySelector('[data-account-view="recover"] .form-message')) {
        this.show('recover');
        if (window.Theme && Theme.openDrawer) setTimeout(() => Theme.openDrawer('account-drawer'), 300);
      }
    }

    disconnectedCallback() {
      if (this.drawer && this.onClose) this.drawer.removeEventListener('drawer:close', this.onClose);
    }

    show(name, focus) {
      const view = this.views.find((v) => v.dataset.accountView === name);
      if (!view) return;
      this.views.forEach((v) => { v.hidden = v !== view; });
      if (this.titleEl && view.dataset.title) this.titleEl.textContent = view.dataset.title;
      if (focus) {
        const field = view.querySelector('input:not([type="hidden"]), button');
        if (field) field.focus();
      }
    }
  }

  customElements.define('account-drawer-views', AccountDrawerViews);
})();
